export const HEADER_LANGUAGES = {
  en_GB: {
    label: 'English',
    icon: '🇬🇧'
  },
  fr_FR: {
    label: 'Français',
    icon: '🇫🇷'
  },
  es_ES: {
    label: 'Español',
    icon: '🇪🇸'
  }
};

export const PAGE_TITLE_SLOT_ID = 'page-title-slot';
